import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import store from './store';
import Dashboard from './pages/Dashboard';
import ImageQuality from './pages/ImageQuality';
import RecordsList from './pages/RecordsList';
import RecordDetail from './pages/RecordDetail';
import ItemDetail from './pages/ItemDetail';
import Login from './pages/Login';
import Forbidden from './pages/Forbidden';
import ProtectedRoute from './components/ProtectedRoute';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#e3f2fd',
      contrastText: '#0d47a1'
    },
    secondary: {
      main: '#dc004e',
    },
    success: {
      main: '#4caf50',
      light: '#e8f5e9',
      contrastText: '#1b5e20'
    },
    error: {
      main: '#f44336',
      light: '#ffebee',
      contrastText: '#b71c1c'
    },
    info: {
      main: '#2196f3',
      light: '#e3f2fd',
      contrastText: '#0d47a1'
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forbidden" element={<Forbidden />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/image-quality" element={<ProtectedRoute><ImageQuality /></ProtectedRoute>} />
            <Route path="/records" element={<ProtectedRoute><RecordsList /></ProtectedRoute>} />
            <Route path="/records/:itemCode/:imageType" element={<ProtectedRoute><RecordDetail /></ProtectedRoute>} />
            <Route path="/items" element={<ProtectedRoute><Navigate to="/" replace /></ProtectedRoute>} />
            <Route path="/items/:itemCode" element={<ProtectedRoute><ItemDetail /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
